import { render, staticRenderFns } from "./all-cookies.vue?vue&type=template&id=c037e948&"
import script from "./all-cookies.vue?vue&type=script&lang=js&"
export * from "./all-cookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports